import check from "../assets/Main/check 1.png";
import React, { useEffect, useState } from "react";
import location from "../assets/Main/Location.png";
import { useSelector } from "react-redux";
import { BASE_URL } from "../services/api";
import { useGetHotelRooms } from "../services/queries";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../components/loading/loadingPage";

const styles = `
  .features-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.75rem;
    padding: 0.5rem;
  }

  .feature-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 6px;
    transition: transform 0.2s ease;
  }

  .feature-box:hover {
    transform: translateY(-1px);
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  }

  .feature-icon-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.25rem;
    background: white;
    border-radius: 50%;
    padding: 0.25rem;
  }

  .feature-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .feature-text {
    margin: 0;
    font-size: 0.75rem;
    text-align: center;
    color: #495057;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    .features-container {
      grid-template-columns: repeat(4, 1fr);
      gap: 0.5rem;
    }
  }

  @media (max-width: 576px) {
    .features-container {
      grid-template-columns: repeat(4, 1fr);
      gap: 0.5rem;
    }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

const HotelCard = () => {
  const { hotelId } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [rooms, setRooms] = useState([]);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const storeDates = useSelector((state) => state.date.dates);
  const [expandedCardId, setExpandedCardId] = useState(null);

  const { data: hotelRooms, isLoading: hotelRoomsLoading } = useGetHotelRooms({
    hotelId,
    lang,
  });
  const currentRooms = useSelector((state) => state.room.rooms.currentRooms);
  useEffect(() => {
    if (currentRooms) {
      setRooms(currentRooms);
    //  console.log("currentRooms", rooms);
    }
  }, [currentRooms]);
  useEffect(() => {
    if (hotelRooms) {
      setRooms(hotelRooms);
   //   console.log("hotelRooms", hotelRooms);
    }
  }, [hotelRooms]);

  useEffect(() => {
    if (storeDates) {
      console.log("storeDatesstoreDatesstoreDatesstoreDatesstoreDatesstoreDates", storeDates);
      setStartDate(new Intl.DateTimeFormat('en-CA').format(storeDates.startDate))
      setEndDate(new Intl.DateTimeFormat('en-CA').format(storeDates.endDate))
    }else{
      const today = new Date();
      today.setDate(today.getDate());
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate()  + 1);
  
      setStartDate(today.toISOString().split("T")[0]);
      setEndDate(tomorrow.toISOString().split("T")[0]);
    }
  }, [storeDates]);
  // if (isLoading) {
  //   <Loader/>
  // }
  return (
    <>
      {hotelRoomsLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <Loader />
        </div>
      ) : (
        rooms?.map((room) => (
          <div key={room.id} className="card border-0 shadow mb-4">
            <div className="row no-gutters">
              {/* Left side: Image */}
              <div className="col-md-4">
                <img
                  src={`${BASE_URL}${room.images[0]}`}
                  className="card-img"
                  alt="Hotel Image"
                />
              </div>

              {/* Right side: Content */}
              <div className="col-md-8">
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div>
                      {/* Hotel Name */}
                      <h5 className="card-title">{room.hotelName}</h5>
                      {/* Hotel Details */}
                      <p className="card-text mb-1">
                        <img src={location} alt="" /> Nabq Bay, Sharm El Sheikh, South Sinai, Egypt
                      </p>
                      <h6>{room.name}</h6>
                      <p>{room.description}</p>
                    </div>
                    <div>
                      {/* Hotel Rating */}
                      <p className="card-text mt-2">
                        <small className="border p-1 rounded">4.2</small> Very
                        Good 371 reviews
                      </p>
                      <div className="text-right">
                        {/* Price */}
                        <span>
                          {room.nights} night, {room.nights+1} days, {room.adult} adult, {room.child}{" "}
                          child
                        </span>
                        <h4 className="text-danger">${room.total}</h4>
                      </div>
                    </div>
                  </div>
                  <div className='features-container'>
                    {room.features.slice(0, expandedCardId === room.id ? room.features.length : 4).map((feature,index)=>
                      <div key={index} className='feature-box'>
                        <div className='feature-icon-wrapper'>
                          <img  
                            src={feature.image ? `${BASE_URL}${feature.image}` : check} 
                            alt={feature.name}
                            className="feature-icon"
                          />
                        </div>
                        <p className='feature-text'>{feature.name}</p>
                      </div>
                    )}
                  </div>
                  {room.features.length > 4 && (
                    <div className="text-center my-2">
                      <button 
                        className="btn btn-link btn-sm p-0"
                        onClick={() => setExpandedCardId(expandedCardId === room.id ? null : room.id)}
                      >
                        {expandedCardId === room.id ? 'Show Less' : 'View More Features'}
                      </button>
                    </div>
                  )}
                  <div className=" border-bottom border-cyan-100 my-4"></div>
                  {/* CTA Buttons */}
                  <div className="row justify-content-around mt-3">
                    {/* <div className="col-2 d-flex justify-content-center align-items-center border rounded cursor-pointer">
                      <i className="far fa-heart"></i>
                    </div> */}
                    <a
  href={`/RoomDetails?roomName=${room.name}&roomId=${room.id}&adult=${room.adult}&child=${room.child}&start=${startDate}&end=${endDate}`}
  // target="_blank"
  rel="noopener noreferrer"
  className="col-9 btn bgPrimaryColor text-white"
>
  View Place
</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default HotelCard;
